<div class="row containers">
  <p-table
    [columns]="cols"
    [value]="dataToDisplay"
    [scrollable]="true"
    [style]="{ width: '100%' }"
    [scrollHeight]="'50vh'"
    [tableStyle]="{ 'min-width': '50rem' }"
    styleClass="p-datatable-sm"
    selectionMode="single"
    (onRowSelect)="onRowSelect($event)"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <ng-container *ngFor="let col of cols">
          <th>
            {{ col.label }}
            <span class="fts">
              <span class="filter" *ngIf="col.showFilter" (click)="toggleCustomColumnFilter(col.name)">
                <ng-container *ngIf="col.filterVals; else notSelected">
                  <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter-selected.png" />
                </ng-container>
                <ng-template #notSelected>
                  <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter.png" />
                </ng-template>
              </span>

              <span class="sort" (click)="sortByColumn(col.name)">
                <ng-container *ngIf="col.hasOwnProperty('isAsc'); else others">
                  <ng-container *ngIf="col.isAsc; else falseBlock">
                    <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-up.png" />
                  </ng-container>
                  <ng-template #falseBlock>
                    <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-down.png" />
                  </ng-template>
                </ng-container>

                <ng-template #others>
                  <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort.png" />
                </ng-template>
              </span>
            </span>
          </th>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <ng-container *ngFor="let col of cols">
          <ng-container *ngIf="col.format === 'html'; else elseBlock">
            <td [innerHtml]="rowData[col.name]"></td>
          </ng-container>
          <ng-template #elseBlock>
            <td>
              {{ col.type === 'date' ? (rowData[col.label] | custdate) : rowData[col.name] }}
            </td>
          </ng-template>
        </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td>No data available in table</td>
      </tr>
    </ng-template>
  </p-table>
</div>
